(() => {
  function pushToDatalayer(items) {
    /* Push to dataLayer */
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items,
      },
    });

    console.log('%cEvent: add_to_cart', 'color: #FF9100');
    console.log(window.dataLayer);
  }

  function handleAddToCart(event) {
    const { quantity, form } = event.detail;
    const node = form.closest('[data-product-card]') || form.closest('.shopify-section');
    const productScriptTag = node.querySelector('[id^="Product-Item-Data-"]');
    if (!productScriptTag) return;

    let sectionScriptTag = false;
    const sectionTag = node.closest('.shopify-section');
    if (sectionTag) sectionScriptTag = sectionTag.querySelector('[id^="Product-List-Data-"]');

    const parsedData = JSON.parse(productScriptTag.innerHTML);
    const itemsWithoutSection = parsedData.items ?? [parsedData];
    const items = itemsWithoutSection.map(item => ({
      ...item, ...{ quantity }, ...sectionScriptTag ? JSON.parse(sectionScriptTag.innerHTML) : {}
    }));

    pushToDatalayer(items);
  }

  function handleCartUpdate(event) {
    const { newQuantity, productData } = event.detail;
    const quantityUpdated = newQuantity - (productData.quantity || 0);
    if (quantityUpdated <= 0) return;

    const items = [{...productData, ...{ quantity: quantityUpdated }}];
    pushToDatalayer(items);
  }

  document.addEventListener('productQuantityChange', handleCartUpdate)
  document.addEventListener('addToCart', handleAddToCart);
})();

